import { render } from "./NewDatasourceFormat.vue?vue&type=template&id=a559921e&scoped=true&ts=true"
import script from "./NewDatasourceFormat.vue?vue&type=script&lang=ts"
export * from "./NewDatasourceFormat.vue?vue&type=script&lang=ts"

import "./NewDatasourceFormat.vue?vue&type=style&index=0&id=a559921e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a559921e"]])

export default __exports__